import { t } from "ttag";

import { ErrorModal } from "@/app/components/legacy-modals";
import { usePortalUserStore } from "@/app/stores";
import { useBoolean } from "@/shared/hooks";
import { CheckableCardsSkeleton, Dialog, Pills3Icon } from "@/shared/ui";
import { useDelayedRefillRequests } from "../hooks";
import { DelayedRefillRequestsSelection } from "./delayed-refill-requests-selection";

export const PendingRefillRequestModal = () => {
  const askForMedicationStatus = usePortalUserStore((state) =>
    Boolean(state.portalUser?.askForMedicationStatus),
  );

  const {
    data: delayedRefillRequests,
    isSuccess,
    isLoading,
    isError,
  } = useDelayedRefillRequests();

  const { value: show, setFalse: onClose } = useBoolean(
    askForMedicationStatus && Boolean(delayedRefillRequests?.length),
  );

  if (isError) {
    return <ErrorModal open={show} onOpenChange={onClose} />;
  }

  return (
    <Dialog.Root open={show}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header icon={Pills3Icon}>
          <Dialog.Title>{t`Have you received your medication?`}</Dialog.Title>

          <div className="flex flex-col">
            <Dialog.Description>
              {t`We haven’t seen any recent activity on your refill request. Please check which medications you have received, and we’ll request a follow-up for the rest.`}
            </Dialog.Description>
          </div>
        </Dialog.Header>

        {isLoading && <CheckableCardsSkeleton />}

        {isSuccess && (
          <DelayedRefillRequestsSelection
            refillRequests={delayedRefillRequests}
            onSuccess={onClose}
          />
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};
